import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Alert, Card, Spinner } from 'react-bootstrap';
import { importVehicleData } from '../services/vehicleDataService';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const AdminImportDataPage = () => {
    const { currentUser, loading: authLoading } = useAuth();
    const [jsonData, setJsonData] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccess('');
        setError('');

        try {
            // Parse the JSON
            const data = JSON.parse(jsonData);
            console.log("JSON verisi işleniyor...");

            // Send to API
            const result = await importVehicleData(data);
            console.log("İçe aktarma sonucu:", result);

            setSuccess(`Veri içe aktarımı başarılı! ${result.count} marka içe aktarıldı.`);
            setJsonData(''); // Clear the form
        } catch (error) {
            console.error('Import error:', error);
            setError(`Hata: ${error.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    // Kullanıcı kimlik doğrulama yükleniyorsa, bekleyin
    if (authLoading) {
        return (
            <Container className="py-5 text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Yükleniyor...</span>
                </Spinner>
                <p className="mt-2">Yetki kontrol ediliyor...</p>
            </Container>
        );
    }

    // Kullanıcı yoksa veya admin değilse, ana sayfaya yönlendir
    if (!currentUser || currentUser.userType !== 'admin') {
        console.log("Admin değil, yönlendiriliyor...");
        return <Navigate to="/" />;
    }

    return (
        <Container className="py-5">
            <h1 className="mb-4">Araç Veri İçe Aktarımı</h1>

            {success && <Alert variant="success">{success}</Alert>}
            {error && <Alert variant="danger">{error}</Alert>}

            <Card>
                <Card.Header>
                    <h5>JSON Veri İçe Aktarımı</h5>
                </Card.Header>
                <Card.Body>
                    <p>Marka, model ve kasa tipi verilerini JSON formatında içe aktarın.</p>

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>JSON Veri</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={20}
                                value={jsonData}
                                onChange={(e) => setJsonData(e.target.value)}
                                placeholder="JSON verisini buraya yapıştırın..."
                                required
                            />
                            <Form.Text muted>
                                Örnek format: {`[{"brand": "Toyota", "models": [{"name": "Corolla", "type": "Sedan"}]}]`}
                            </Form.Text>
                        </Form.Group>

                        <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? 'İçe Aktarılıyor...' : 'Verileri İçe Aktar'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default AdminImportDataPage;